var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMoreInfoOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "More_information",
    "data-name": "More information",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Frame",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information-button",
    transform: "translate(6.088 6.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5897",
    "data-name": "Path 5897",
    d: "M5.911,0a5.912,5.912,0,1,0,5.912,5.911A5.912,5.912,0,0,0,5.911,0ZM7.142,9.162q-.456.18-.728.274a1.921,1.921,0,0,1-.632.095,1.259,1.259,0,0,1-.859-.27.87.87,0,0,1-.306-.684,2.485,2.485,0,0,1,.023-.33c.016-.112.04-.238.074-.38l.381-1.345c.034-.129.063-.252.086-.366a1.622,1.622,0,0,0,.034-.317.488.488,0,0,0-.106-.359.6.6,0,0,0-.407-.1,1.068,1.068,0,0,0-.3.045c-.1.032-.192.06-.265.088l.1-.414q.374-.152.716-.261A2.114,2.114,0,0,1,5.6,4.729a1.235,1.235,0,0,1,.847.265.881.881,0,0,1,.3.689q0,.088-.021.309a2.066,2.066,0,0,1-.076.406L6.264,7.739c-.031.108-.059.231-.084.368a1.948,1.948,0,0,0-.037.313.45.45,0,0,0,.12.364.67.67,0,0,0,.414.1,1.2,1.2,0,0,0,.313-.049,1.781,1.781,0,0,0,.253-.085ZM7.075,3.718a.9.9,0,0,1-.638.246A.914.914,0,0,1,5.8,3.718a.786.786,0,0,1-.267-.6.794.794,0,0,1,.267-.6.907.907,0,0,1,.641-.249.9.9,0,0,1,.638.249.806.806,0,0,1,0,1.2Z",
    fill: "#ed8b00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreInfoOrange);
export default __webpack_public_path__ + "static/media/icon_more_info_orange.f2a1bcf25951108b279f03d1107c0ad9.svg";
export { ForwardRef as ReactComponent };